import { Helper } from '@/mixin/helper'
import { setNavSource } from '@/helpers/navigation-guards'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']
const getFeatureFlagData = store.getters['identity/getFeatureFlagData']
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

export default [
  {
    path: '/delivery',
    name: 'Delivery',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery'),
  },
  {
    path: '/delivery/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery/import'),
    children: [
      {
        path: '',
        name: 'Delivery Import',
        component: () => import('@/router/views/delivery/import/contents/Upload.vue'),
      },
      {
        path: ':id',
        name: 'Delivery Import Detail',
        component: () => import('@/router/views/delivery/import/contents/Process.vue'),
      },
      {
        path: ':id/result',
        name: 'Delivery Import Result',
        component: () => import('@/router/views/delivery/import/contents/Result.vue'),
      },
    ],
  },
  {
    path: '/delivery/create',
    name: 'Delivery Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    beforeEnter: setNavSource,
    component: () => import('@/router/views/delivery/form'),
  },
  {
    path: '/delivery/create-bulk',
    name: 'Delivery Create Bulk',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery/create-bulk'),
  },
  {
    path: '/delivery/:id',
    name: 'Delivery Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    beforeEnter: setNavSource,
    component: () => import('@/router/views/delivery/form'),
  },
  {
    path: '/delivery/accurate/list',
    name: 'Delivery Accurate',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'tms-integration-accurate:create',
          'tms-integration-accurate:read',
          'tms-integration-accurate:update',
          'tms-integration-accurate:delete']) 
        
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery/accurate'),
  },
  {
    path: '/delivery/invoice/form',
    name: 'Delivery Invoice',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'tms-integration-accurate:create',
          'tms-integration-accurate:read',
          'tms-integration-accurate:update',
          'tms-integration-accurate:delete'])
        
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/invoice/form'),
  },
  {
    path: '/invoice',
    name: 'Invoice List',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'tms-integration-accurate:create',
          'tms-integration-accurate:read',
          'tms-integration-accurate:update',
          'tms-integration-accurate:delete']) 
          && getFeatureFlagData('invoiceCoreFlag').value
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/invoice'),
  },
  {
    path: '/invoice/create',
    name: 'Invoice Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, __, next) {
        const acc = hasAccessAll([
          'tms-integration-accurate:create',
          'tms-integration-accurate:read',
          'tms-integration-accurate:update',
          'tms-integration-accurate:delete']) 
          && getFeatureFlagData('invoiceCoreFlag').value
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/invoice/delivery-list')
  },
  {
    path: '/invoice/form',
    name: 'Invoice Form',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, __, next) {
        //TODO change later after scope is defined
        const acc = hasAccessAll([
          'tms-integration-accurate:create',
          'tms-integration-accurate:read',
          'tms-integration-accurate:update',
          'tms-integration-accurate:delete']) 
          && getFeatureFlagData('invoiceCoreFlag').value
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/invoice/invoice-form')
  },
  {
    path: '/delivery/track/:data',
    name: 'Track DO',
    meta: {
      guestPage: true,
      hasAccess: true,
    },
    component: () => import('@/router/views/delivery/track/index'),
  },
]
